import * as React from "react";
const SvgCompany = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 38,
	height: 33,
	viewBox: "0 0 38 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M26.6 6.94737H34.2C36.309 6.94737 38 8.49316 38 10.4211V29.5263C38 31.4542 36.309 33 34.2 33H3.8C1.691 33 0 31.4542 0 29.5263L0.019 10.4211C0.019 8.49316 1.691 6.94737 3.8 6.94737H11.4V3.47368C11.4 1.54579 13.091 0 15.2 0H22.8C24.909 0 26.6 1.54579 26.6 3.47368V6.94737ZM15.2 6.94737H22.8V3.47368H15.2V6.94737Z",
	fill: "white"
}));
export default SvgCompany;
